import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {
    detailPeriodeChannel = new Subject();



    processChannel = new Subject()
    downloadDraftSKChannel = new Subject()
    exportUsulanChannel = new Subject()
    inputSKChannel = new Subject()
    createSKCChannel = new Subject()
    listSKCChannel = new Subject()
    downloadSKCChannel = new Subject()
    exportRapelChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.processChannel.next({status: apiResponse.INITIAL})
        this.downloadDraftSKChannel.next({status: apiResponse.INITIAL})
        this.exportUsulanChannel.next({status: apiResponse.INITIAL})
        this.inputSKChannel.next({status: apiResponse.INITIAL})

        this.createSKCChannel.next({status: apiResponse.INITIAL})
        this.listSKCChannel.next({status: apiResponse.INITIAL})
        this.downloadSKCChannel.next({status: apiResponse.INITIAL})

        this.detailPeriodeChannel.next({status: apiResponse.INITIAL})

    }

    fetchDetailPeriode = async (query) => {
        try {
            this.detailPeriodeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailPeriodeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailPeriodeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    fetchInputSK = async (query) => {
        try {
            this.inputSKChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInputSK(query).then((result) => {
                this.inputSKChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inputSKChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchProcess = async (query) => {
        try {
            this.processChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchProcess(query).then((result) => {
                this.processChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.processChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchDownloadDraftSK = async (query) => {
        try {
            this.downloadDraftSKChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadDraftSK(query).then((result) => {
                this.downloadDraftSKChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadDraftSKChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchExportUsulan = async (query) => {
        try {
            this.exportUsulanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportUsulan(query).then((result) => {
                this.exportUsulanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportUsulanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchCreateSKC = async (query) => {
        try {
            this.createSKCChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreateSKC(query).then((result) => {
                this.createSKCChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createSKCChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchListSKC = async (query) => {
        try {
            this.listSKCChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListSKC(query).then((result) => {
                this.listSKCChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listSKCChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchDownloadSKC = async (query) => {
        try {
            this.downloadSKCChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadSKC(query).then((result) => {
                this.downloadSKCChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadSKCChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchExport = async (query) => {
        try {
            this.exportRapelChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExport(query).then((result) => {
                this.exportRapelChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportRapelChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
}

export default IndexBloc